import { HTTPError } from 'ky';

interface ErrorResponse {
  [key: string]: unknown;
}

export class AppError<B> extends HTTPError {
  body = {} as B;
  name = 'AppError';

  constructor(error: HTTPError) {
    super(error.response, error.request, error.options);

    this.name = 'AppError';
    this.message = `HTTP Error ${error.response.status}: ${error.response.statusText}`;

    Object.assign(this, error);
  }

  async json() {
    try {
      const body = await this.response.json();
      this.body = body as B;

      if (typeof this.body === 'object' && this.body !== null) {
        const errorBody = this.body as ErrorResponse;
        this.message += ` - ${JSON.stringify(errorBody)}`;
      }
    } catch (e) {
      this.body = {
        status: this.response.status,
        statusText: this.response.statusText,
        error: e instanceof Error ? e.message : String(e),
      } as B;
    }
  }
}
